import {
  ADD_REQUEST_REQUEST,
  ADD_REQUEST_SUCCESS,
  ADD_REQUEST_FAILURE,
  FETCH_REQUESTS_REQUEST,
  FETCH_REQUESTS_SUCCESS,
  FETCH_REQUESTS_FAILURE,
  FETCH_PENDING_UPLOAD_REQUESTS_REQUEST,
  FETCH_PENDING_UPLOAD_REQUESTS_SUCCESS,
  FETCH_PENDING_UPLOAD_REQUESTS_FAILURE,
  FETCH_PENDING_APPROVAL_REQUESTS_REQUEST,
  FETCH_PENDING_APPROVAL_REQUESTS_SUCCESS,
  FETCH_PENDING_APPROVAL_REQUESTS_FAILURE,
  FETCH_REQUEST_TYPES_REQUEST,
  FETCH_REQUEST_TYPES_SUCCESS,
  FETCH_REQUEST_TYPES_FAILURE,
  UPDATE_REQUEST_REQUEST,
  UPDATE_REQUEST_SUCCESS,
  UPDATE_REQUEST_FAILURE,
  DELETE_REQUEST_REQUEST,
  DELETE_REQUEST_SUCCESS,
  DELETE_REQUEST_FAILURE,
  CLEAR_REQUESTS_ERROR,
  FETCH_REQUEST_PAYMENT_CODE,
  FETCH_REQUEST_PAYMENT_CODE_SUCCESS,
  FETCH_REQUEST_PAYMENT_CODE_FAILURE,
  RESET_PAYMENT_CODE_DETAILS,
  UPLOAD_RECEIPT_REQUEST,
  UPLOAD_RECEIPT_SUCCESS,
  UPLOAD_RECEIPT_FAILURE,
  FETCH_RECEIPT_REQUEST,
  FETCH_RECEIPT_SUCCESS,
  FETCH_RECEIPT_FAILURE,
  APPROVE_RECEIPT_REQUEST,
  APPROVE_RECEIPT_SUCCESS,
  APPROVE_RECEIPT_FAILURE,
  REQUIRE_RECEIPT_REQUEST,
  REQUIRE_RECEIPT_SUCCESS,
  REQUIRE_RECEIPT_FAILURE,
  RECALL_REQUEST_REQUEST,
  RECALL_REQUEST_SUCCESS,
  RECALL_REQUEST_FAILURE,
} from "../actions/requestActionTypes";

const initialState = {
  requests: [],
  requestTypes: [],
  isLoading: false,
  addRequestError: null,
  fetchRequestsError: null,
  fetchPendingReceiptUploadsError: null,
  fetchPendingReceiptApprovalsError: null,
  fetchRequestTypesError: null,
  updateRequestError: null,
  deleteRequestError: null,
  paymentCodeDetails: null,
  receipt: null,
  receiptError: null,
  approveReceiptError: null,
  requireReceiptError: null,
  recallRequestError: null,
};

const requestReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_REQUEST_REQUEST:
      return { ...state, isLoading: true, addRequestError: null };
    case ADD_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        requests: [...state.requests, action.payload],
        addRequestError: null,
      };
    case ADD_REQUEST_FAILURE:
      return { ...state, isLoading: false, addRequestError: action.payload };

    case FETCH_REQUESTS_REQUEST:
    case FETCH_PENDING_UPLOAD_REQUESTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        fetchRequestsError: null,
        fetchPendingReceiptUploadsError: null,
      };
    case FETCH_PENDING_APPROVAL_REQUESTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        fetchRequestsError: null,
        fetchPendingReceiptApprovalsError: null,
      };
    case FETCH_REQUESTS_SUCCESS:
    case FETCH_PENDING_UPLOAD_REQUESTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        requests: action.payload.map((request) => ({
          ...request,
          requestId: request.requestId || request.id,
          requestType:
            request.requestType === "Executive Request"
              ? "Executive"
              : request.requestType,
        })),
        fetchRequestsError: null,
        fetchPendingReceiptUploadsError: null,
      };
    case FETCH_PENDING_APPROVAL_REQUESTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        requests: action.payload.map((request) => ({
          ...request,
          requestId: request.requestId || request.id,
          requestType:
            request.requestType === "Executive Request"
              ? "Executive"
              : request.requestType,
        })),
        fetchRequestsError: null,
        fetchPendingReceiptApprovalsError: null,
      };
    case FETCH_REQUESTS_FAILURE:
      return { ...state, isLoading: false, fetchRequestsError: action.payload };
    case FETCH_PENDING_UPLOAD_REQUESTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        fetchPendingReceiptUploadsError: action.payload,
      };
    case FETCH_PENDING_APPROVAL_REQUESTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        fetchPendingReceiptApprovalsError: action.payload,
      };

    case FETCH_REQUEST_TYPES_REQUEST:
      return { ...state, isLoading: true, fetchRequestTypesError: null };
    case FETCH_REQUEST_TYPES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        requestTypes: action.payload,
        fetchRequestTypesError: null,
      };
    case FETCH_REQUEST_TYPES_FAILURE:
      return {
        ...state,
        isLoading: false,
        fetchRequestTypesError: action.payload,
      };

    case UPDATE_REQUEST_REQUEST:
      return { ...state, isLoading: true, updateRequestError: null };
    case UPDATE_REQUEST_SUCCESS:
      return {
        ...state,
        requests: state.requests.map((request) =>
          (request.requestId || request.id) === action.payload.requestId
            ? {
                ...action.payload,
                requestId: action.payload.requestId || action.payload.id,
              }
            : request,
        ),
        isLoading: false,
        updateRequestError: null,
      };
    case UPDATE_REQUEST_FAILURE:
      return { ...state, isLoading: false, updateRequestError: action.payload };

    case DELETE_REQUEST_REQUEST:
      return { ...state, isLoading: true, deleteRequestError: null };
    case DELETE_REQUEST_SUCCESS:
      return {
        ...state,
        requests: state.requests.filter(
          (request) => (request.requestId || request.id) !== action.payload,
        ),
        isLoading: false,
        deleteRequestError: null,
      };
    case DELETE_REQUEST_FAILURE:
      return { ...state, isLoading: false, deleteRequestError: action.payload };

    case FETCH_REQUEST_PAYMENT_CODE:
      return { ...state, isLoading: true, fetchPaymentCodeError: null };
    case FETCH_REQUEST_PAYMENT_CODE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentCodeDetails: action.payload,
      };
    case FETCH_REQUEST_PAYMENT_CODE_FAILURE:
      return {
        ...state,
        isLoading: false,
        fetchPaymentCodeError: action.payload,
      };

    case RESET_PAYMENT_CODE_DETAILS:
      return { ...state, paymentCodeDetails: null };

    case UPLOAD_RECEIPT_REQUEST:
      return { ...state, isLoading: true, receiptError: null };
    case UPLOAD_RECEIPT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        receipt: action.payload,
        receiptError: null,
      };
    case UPLOAD_RECEIPT_FAILURE:
      return { ...state, isLoading: false, receiptError: null };

    case FETCH_RECEIPT_REQUEST:
      return { ...state, isLoading: true, receiptError: null };
    case FETCH_RECEIPT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        receipt: action.payload,
        receiptError: null,
      };
    case FETCH_RECEIPT_FAILURE:
      return { ...state, isLoading: false, receiptError: action.payload };

    case APPROVE_RECEIPT_REQUEST:
      return { ...state, isLoading: true, approveReceiptError: null };
    case APPROVE_RECEIPT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        requests: state.requests.map((request) =>
          (request.requestId || request.id) === action.payload.requestId
            ? { ...request, statusName: "Approved" }
            : request,
        ),
        approveReceiptError: null,
      };
    case APPROVE_RECEIPT_FAILURE:
      return {
        ...state,
        isLoading: false,
        approveReceiptError: action.payload,
      };

    case REQUIRE_RECEIPT_REQUEST:
      return { ...state, isLoading: true, requireReceiptError: null };
    case REQUIRE_RECEIPT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        requests: state.requests.map((request) =>
          (request.requestId || request.id) === action.payload.requestId
            ? { ...request, requiresReceipt: true }
            : request,
        ),
        requireReceiptError: null,
      };
    case REQUIRE_RECEIPT_FAILURE:
      return {
        ...state,
        isLoading: false,
        requireReceiptError: action.payload,
      };

    case RECALL_REQUEST_REQUEST:
      return { ...state, isLoading: true, recallRequestError: null };
    case RECALL_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        requests: state.requests.map((request) =>
          (request.requestId || request.id) === action.payload.requestId
            ? { ...request, statusName: "Recalled" }
            : request,
        ),
        recallRequestError: null,
      };
    case RECALL_REQUEST_FAILURE:
      return {
        ...state,
        isLoading: false,
        recallRequestError: action.payload,
      };

    case CLEAR_REQUESTS_ERROR:
      return {
        ...state,
        addRequestError: null,
        fetchRequestsError: null,
        fetchPendingReceiptUploadsError: null,
        fetchPendingReceiptApprovalsError: null,
        fetchRequestTypesError: null,
        updateRequestError: null,
        deleteRequestError: null,
        receiptError: null,
        approveReceiptError: null,
        requireReceiptError: null,
        recallRequestError: null,
      };

    default:
      return state;
  }
};

export default requestReducer;
